// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import InstructionsList from './instructions-list';
import SpecialInstruction from '@deere/cps-it.warranty-model-factory/lib/special-instruction';

const SpecialInstructions = props => {

    const title = <FormattedMessage id='SPECIAL_INSTRUCTIONS'/>;

    const body = <InstructionsList instructions={props.specialInstructions}/>;

    return (
        props.specialInstructions.length > 0 &&
            <Accordion
                accordionId='special-instructions-accordion'
                body={body}
                isExpanded={true}
                title={title}
            />
    );

};

SpecialInstructions.displayName = 'SpecialInstructions';
SpecialInstructions.propTypes = {
    specialInstructions: PropTypes.arrayOf(PropTypes.instanceOf(SpecialInstruction)).isRequired
};

export default SpecialInstructions;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/instructions-panels/special-instructions.js